import { Button, FormControl, InputLabel, makeStyles, MenuItem, OutlinedInput, Select } from '@material-ui/core';
import * as React from 'react';
import { planEatApi } from '../../../planEatApi/PlanEatApi';
import { IOfficeContent, IVersionedObject } from '../../../planEatApi/PlanEatFacade';
import { OfficeContext } from '../../../config/Context';
import { useEffect } from 'react';
import { monthAbbreviations, months, years } from '../../../constants/dateAbbreviations';
import { InputContainer } from '../../../components/ui/InputContainer';

const useStyles = makeStyles((theme: any) => ({
    title: {
        fontSize: 20,
        fontWeight: 700,
    }, 
    addMenuItemInputContainer:{
        width: '100%',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        marginTop: 30,
        padding: 30
    },
    twoItemRow:{
        display: 'grid',
        gridTemplateColumns: '25% 25%',
        justifyContent: 'flex-start',
        columnGap: 20,
        marginBottom: 20
    },
    oneItemRow:{
        paddingTop: 40,
        display: 'grid',
        gridTemplateColumns: '100%',
        gridTemplateRow: '100%'
    },
    buttonContainer:{
        display: 'grid',
        justifyContent: 'flex-end',
        gridTemplateColumns: '30%',
        width: '100%',
    },
    inputTitle:{
        fontSize: 18,
        fontWeight: 700,
        paddingBottom: 15
    },
}));

interface Props {
    month: number,
    year: number
}

export const AdminInvoices: React.FC<Props> = ({}) => {
    // Styling
    const classes = useStyles();

    // State
    const [month, setMonth] = React.useState((new Date().getMonth()+1).toString());
    const [year, setYear] = React.useState(new Date().getUTCFullYear().toString());
    const [offices, setOffices] = React.useState<IVersionedObject<IOfficeContent>[]>([]);
    const [officeId, setOfficeId] = React.useState('');

    // Context
    const officeContext = React.useContext(OfficeContext);

    useEffect(() => {
        getOffices();
    },[])

    useEffect(() => {
        if(officeContext?.office){
            setOfficeId(officeContext.office.content.id)
        }
    },[officeContext])

    const getIncoicing = () =>{
        if(officeContext?.office){
            planEatApi.getInvoicing(officeContext?.office.content.id,month.toString(),year.toString())
            .then((response) =>{
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                var officeName = officeContext?.office ? officeContext?.office.content.officeName : ""
                link.setAttribute('download', officeName + "_" + monthAbbreviations[parseInt(month)-1] + '_' + year + '_' + 'invoicing.csv'); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
            .catch((e) => {
                console.log(e)
            })
        }
    }

    useEffect(() => {
        getOffices()
    },[officeContext])

    const getOffices = async () => {
        await planEatApi.getOffices().then((response) => {
            setOffices(response.data)
        })
    }
    
    const handleMonthChange = (event: any) => {
        setMonth(event.target.value);
    };

    const handleYearChange = (event: any) => {
        setYear(event.target.value);
    };

    const handleOfficeIdChange = (event: any) => {
        setOfficeId(event.target.value);
    };

    return (
        <div>
            <div className={classes.title}>
                Choose invoice
            </div>

            <div className={classes.addMenuItemInputContainer}> 
                <InputContainer>
                    <FormControl variant="outlined" style={{marginTop:10}}>
                        <InputLabel shrink>Office</InputLabel>
                        <Select
                            input={<OutlinedInput notched label="Office" />}
                            label='Office'
                            variant='outlined'
                            value={officeId}
                            onChange={handleOfficeIdChange}
                            fullWidth

                        >
                        {offices.map((office) => <MenuItem key={office.content.id} value={office.content.id}>{office.content.officeName}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" style={{marginTop:10}}>
                        <InputLabel shrink>Month</InputLabel>
                        <Select
                            input={<OutlinedInput notched label="Month" />}
                            label='Month'
                            variant='outlined'
                            defaultValue={month}
                            onChange={handleMonthChange}
                            fullWidth
                        >
                            {months.map((tmpMonth) => <MenuItem key={tmpMonth.value} value={tmpMonth.value}>{tmpMonth.month}</MenuItem>)}    
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" style={{marginTop:10}}>
                        <InputLabel shrink>Year</InputLabel>
                        <Select
                            input={<OutlinedInput notched label="Year" />}
                            label='Year'
                            variant='outlined'
                            value={year}
                            onChange={handleYearChange}
                            fullWidth
                        >
                            {years.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)}
                        </Select>
                    </FormControl>
                </InputContainer>
                <div className={classes.oneItemRow}>
                    <div className={classes.buttonContainer}>
                        <Button variant="contained" onClick={() => {getIncoicing()}}>
                            Download
                        </Button>
                    </div>
                </div> 
             </div>
        </div>
    );
}